// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-alert.v-sheet[data-v-6d88aa82]{background-color:#fdebe2 !important;font-size:12px}", ""]);
// Exports
module.exports = exports;
